// Форма проекта в виде страницы сайта (эпик DEV-2347). Пока флаг выключен,
// create/edit открывают прежнюю форму. Включается ключом в
// cloud/k8s-infrastructure/features/<env>.json; локально в `npm run dev` —
// localStorage.setItem('ff', '{"dev-2347-rc-wysiwyg-form":true}').
export const RC_WYSIWYG_FORM_FLAG = 'dev-2347-rc-wysiwyg-form'
